import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { ErrorResponse } from '@core/error/error-response.model';


/**
 * Form error display widget
 */
@Component({
    selector: 'app-form-error',
    templateUrl: './form-error.component.html',
    styleUrls: ['./form-error.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormErrorComponent {
    public readonly error: InputSignal<ErrorResponse> = input();
}
